export default {
    'langs':'language',
    'zh':'Chinese',
    'test':'test',
    'yhdl':'Users Login',
    'tcdl':'log out',
    'xtgl':'System management',
    'kczx':"Course center",
    'jssbgl':'One-stop ai teaching platform',
    'jtpt':'Device management',
    'yhm':'Username',
    'gh':'Job number',
}